<!-- BILLING -->
<div class="cx-payment-form-billing">
  <div class="cx-payment-form-billing-address">
    {{ 'paymentForm.billingAddress' | cxTranslate }}
  </div>

  <!-- SAME AS SHIPPING CHECKBOX -->
  <ng-container *ngIf="showSameAsDeliveryAddressCheckbox$ | async">
    <div class="form-group">
      <div class="form-check">
        <label>
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="sameAsDeliveryAddress"
            (change)="toggleSameAsDeliveryAddress()"
            [attr.aria-label]="
              'paymentForm.billingAddressSameAsShipping' | cxTranslate
            "
          />
          <span class="form-check-label">{{
            'paymentForm.sameAsDeliveryAddress' | cxTranslate
          }}</span>
        </label>
      </div>
    </div>
  </ng-container>

  <!-- BILLING INFO COMPONENT -->
  <ng-container
    *ngIf="
      sameAsDeliveryAddress && (deliveryAddress$ | async) as deliveryAddress;
      else billingAddress
    "
  >
    <cx-card [content]="getAddressCardContent(deliveryAddress)"></cx-card>
  </ng-container>

  <!-- TODO:#future-checkout do we really want this? We can always pass more inputs to the copied address form component to make it more modular -->
  <ng-template #billingAddress>
    <div [formGroup]="billingAddressForm">
      <p *cxFeature="'a11yRequiredAsterisks'" class="form-legend">
        {{ 'formLegend.required' | cxTranslate }}
      </p>
      <div class="form-group" formGroupName="country">
        <ng-container *ngIf="countries$ | async as countries">
          <div *ngIf="countries.length !== 0">
            <label>
              <span class="label-content required">
                {{ 'addressForm.country' | cxTranslate }}
                <ng-template
                  [ngTemplateOutlet]="requiredAsterisk"
                ></ng-template>
              </span>
              <ng-select
                [inputAttrs]="{ required: 'true' }"
                [searchable]="true"
                [clearable]="false"
                [items]="countries"
                bindLabel="name"
                bindValue="isocode"
                placeholder="{{ 'addressForm.selectOne' | cxTranslate }}"
                (change)="countrySelected($event)"
                formControlName="isocode"
                id="country-payment-select"
                [cxNgSelectA11y]="{
                  ariaLabel: 'addressForm.country' | cxTranslate,
                }"
              >
              </ng-select>
              <cx-form-errors
                [control]="billingAddressForm.get('country.isocode')"
              ></cx-form-errors>
            </label>
          </div>
        </ng-container>
      </div>
      <div class="form-group">
        <label>
          <span class="label-content required">
            {{ 'addressForm.firstName.label' | cxTranslate }}
            <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
          </span>
          <input
            required="true"
            class="form-control"
            type="text"
            placeholder="{{
              'addressForm.firstName.placeholder' | cxTranslate
            }}"
            formControlName="firstName"
            [attr.aria-describedby]="'firstNameError'"
          />
          <cx-form-errors
            id="firstNameError"
            aria-live="off"
            [control]="billingAddressForm.get('firstName')"
          ></cx-form-errors>
        </label>
      </div>
      <div class="form-group">
        <label>
          <span class="label-content required">
            {{ 'addressForm.lastName.label' | cxTranslate }}
            <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
          </span>
          <input
            required="true"
            type="text"
            class="form-control"
            placeholder="{{ 'addressForm.lastName.placeholder' | cxTranslate }}"
            formControlName="lastName"
            [attr.aria-describedby]="'lastNameError'"
          />
          <cx-form-errors
            id="lastNameError"
            aria-live="off"
            [control]="billingAddressForm.get('lastName')"
          ></cx-form-errors>
        </label>
      </div>
      <div class="form-group">
        <label>
          <span class="label-content required">
            {{ 'addressForm.address1' | cxTranslate }}
            <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
          </span>
          <input
            required="true"
            type="text"
            class="form-control"
            placeholder="{{ 'addressForm.streetAddress' | cxTranslate }}"
            formControlName="line1"
            [attr.aria-describedby]="'line1Error'"
          />
          <cx-form-errors
            id="line1Error"
            aria-live="off"
            [control]="billingAddressForm.get('line1')"
          ></cx-form-errors>
        </label>
      </div>
      <div class="form-group">
        <label>
          <span class="label-content">{{
            'addressForm.address2' | cxTranslate
          }}</span>
          <input
            type="text"
            class="form-control"
            placeholder="{{ 'addressForm.aptSuite' | cxTranslate }}"
            formControlName="line2"
          />
        </label>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label>
            <span class="label-content required">
              {{ 'addressForm.city.label' | cxTranslate }}
              <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
            </span>
            <input
              required="true"
              type="text"
              class="form-control"
              placeholder="{{ 'addressForm.city.placeholder' | cxTranslate }}"
              formControlName="town"
              [attr.aria-describedby]="'townError'"
            />
            <cx-form-errors
              id="townError"
              aria-live="off"
              [control]="billingAddressForm.get('town')"
            ></cx-form-errors>
          </label>
        </div>
        <div class="form-group col-md-6">
          <label>
            <span class="label-content required">
              {{ 'addressForm.zipCode.label' | cxTranslate }}
              <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
            </span>
            <input
              required="true"
              type="text"
              class="form-control"
              placeholder="{{
                'addressForm.zipCode.placeholder' | cxTranslate
              }}"
              formControlName="postalCode"
              [attr.aria-describedby]="'postalCodeError'"
            />
            <cx-form-errors
              id="postalCodeError"
              aria-live="off"
              [control]="billingAddressForm.get('postalCode')"
            ></cx-form-errors>
          </label>
        </div>
        <ng-container
          *ngIf="regions$ | async as regions"
          formGroupName="region"
        >
          <ng-container *ngIf="regions.length !== 0">
            <div class="form-group col-md-6">
              <label>
                <span class="label-content required">{{
                  'addressForm.state' | cxTranslate
                }}</span>
                <ng-select
                  [inputAttrs]="{ required: 'true' }"
                  class="region-select"
                  formControlName="isocodeShort"
                  [searchable]="true"
                  [clearable]="false"
                  [items]="regions"
                  bindLabel="{{ regions[0].name ? 'name' : 'isocodeShort' }}"
                  bindValue="{{ regions[0].name ? 'isocodeShort' : 'region' }}"
                  placeholder="{{ 'addressForm.selectOne' | cxTranslate }}"
                  id="region-select"
                  [cxNgSelectA11y]="{
                    ariaLabel: 'addressForm.state' | cxTranslate,
                  }"
                >
                </ng-select>
                <cx-form-errors
                  [control]="billingAddressForm.get('region.isocodeShort')"
                ></cx-form-errors>
              </label>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #requiredAsterisk>
  <abbr
    *cxFeature="'a11yRequiredAsterisks'"
    class="text-decoration-none required-asterisk"
    aria-hidden="true"
    title="{{ 'common.required' | cxTranslate }}"
    >*</abbr
  >
</ng-template>
